import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#D32F2F' },
    secondary: { main: '#FFCDD2' },
    background: { default: '#fff' },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    button: { textTransform: 'none', fontWeight: 600 },
  },
});

export default theme;
